// extracted by mini-css-extract-plugin
module.exports = {"bannerModal":"popup-banners_bannerModal__DXXip","banners":"popup-banners_banners__nK5NV","close":"popup-banners_close__yqf_k","bannerItem":"popup-banners_bannerItem__fMLVH"};